<template>
  <div class="icon-container" :style="getGiftBackgroundStyle">
    <template v-for="(gift, index) in showIconList">
      <img
        v-if="getGameIcon(gift)"
        class="icon"
        :class="`gift-icon-${index}`"
        :src="getGameIcon(gift)"
        alt="icon"
      />
    </template>
  </div>
</template>

<script>
import themeMixins from '@mixins/officialTopup/themeMixins';
import icon from '@mixins/officialTopup/icon';

export default {
  props: {
    background: {
      type: String,
      default: ''
    },
    gifts: {
      type: Array,
      default: () => []
    }
  },
  mixins: [themeMixins, icon],
  computed: {
    showIconList() {
      // 最多展示3个
      return this.gifts.slice(0, 3);
    },
    getGiftBackgroundStyle() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.icon-container {
  border-radius: 20px 20px 0 0;
  position: relative;
  width: 100%;
  height: 190px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    position: absolute;
    cursor: pointer;
    width: 110px;
    height: 110px;
  }

  @for $i from 0 through 5 {
    .gift-icon-#{$i} {
      z-index: 5-$i;

      @if $i %2 == 0 {
        transform: translateX(#{$i * 25%});
      } @else {
        transform: translateX(-#{$i * 25% + 25%});
      }
    }
  }
}
</style>
